<template>
  <layout :menu="menu">
    <template v-slot:toolbar-left>
      <logo-toolbar></logo-toolbar>
      <title-toolbar></title-toolbar>
    </template>

    <template v-slot:toolbar-right>

      <!-- BAR  TAKEAWAY or DELIVERY -->
      <v-btn  v-if="me && $store.getters.hasPermission('ORDER_SHOW_BAR')" icon dark :to="{name: 'BarOrderPage'}">
        <v-icon>storefront</v-icon>
      </v-btn>

      <v-btn  v-if="me && $store.getters.hasPermission('ORDER_SHOW_BAR')" icon dark :to="{name: 'OrderFlowPage'}">
        <v-icon>manage_history</v-icon>
      </v-btn>

      <v-btn  v-if="me && $store.getters.hasPermission('ORDER_SHOW_BAR')" icon dark :to="{name: 'OrderFlowAllPage'}">
        <v-icon>select_all</v-icon>
      </v-btn>

      <!-- RESTAURANT -->
      <v-btn  v-if="me && $store.getters.hasPermission('ORDER_SHOW_SALON')" icon dark :to="{name: 'SalonOrderPage'}">
        <v-icon>restaurant</v-icon>
      </v-btn>

      <v-btn  v-if="me && $store.getters.hasPermission('ORDER_SHOW_SALON')" icon dark :to="{name: 'OrderFlowSalonPage'}">
        <v-icon>table_chart</v-icon>
      </v-btn>


      <!-- SETTING EXPRESS -->
      <setting-express v-if="me && $store.getters.hasPermission('ORDER_SHOW_BAR')"></setting-express>



      <!-- CAMARERO -->
      <v-btn  v-if="me && !$store.getters.hasPermission('ORDER_SHOW_BAR') && $store.getters.hasPermission('ORDER_SHOW_WAITER')" icon dark :to="{name: 'OrderFlowWaiterPage'}">
        <v-icon>tapas</v-icon>
      </v-btn>


      <!-- COCINA -->
      <v-btn  v-if="me && !$store.getters.hasPermission('ORDER_SHOW_BAR') && $store.getters.hasPermission('ORDER_SHOW_KITCHEN')"
              icon dark :to="{name: 'OrderFlowKitchenPage'}">
        <v-icon>kitchen</v-icon>
      </v-btn>

      <!-- OVEN -->
      <v-btn  v-if="me && !$store.getters.hasPermission('ORDER_SHOW_BAR') && $store.getters.hasPermission('ORDER_SHOW_OVEN')"
              icon dark :to="{name: 'OrderFlowOvenPage'}">
        <v-icon>microwave</v-icon>
      </v-btn>

      <!-- DELIVERY -->
      <v-btn  v-if="me && !$store.getters.hasPermission('ORDER_SHOW_BAR') && $store.getters.hasPermission('ORDER_SHOW_DELIVERY')"
              icon dark :to="{name: 'OrderFlowDeliveryPage'}">
        <v-icon>moped</v-icon>
      </v-btn>

      <v-btn  v-if="me" icon dark :to="{name: 'HomeAdminPage'}">
        <v-icon>dashboard</v-icon>
      </v-btn>

      <dashboard-button/>

      <app-bar-user-menu v-if="me"/>

      <shooping-cart-button v-else-if="$route.name != 'CustomerOrderPage'"></shooping-cart-button>

    </template>

    <router-view :key="$route.fullPath"></router-view>

    <error-snackbar></error-snackbar>
    <sound-alarm v-if="me"></sound-alarm>
  </layout>
</template>

<script>
import Layout from "./layout/Layout";
import menuConfig from './menu-config'
import {DashboardButton, AppBarUserMenu} from '@dracul/user-frontend'
import {LogoToolbar, TitleToolbar} from '@dracul/customize-frontend'
import {mapGetters} from "vuex";
import ErrorSnackbar from "@/modules/base/components/ErrorSnackbar/ErrorSnackbar";
import ShoopingCartButton from "@/modules/delivery/components/ShoppingCartButton/ShoopingCartButton";
import SoundAlarm from "@/modules/delivery/components/SoundAlarm/SoundAlarm";
import SettingExpress from "@/modules/delivery/components/SettingExpress/SettingExpress";

export default {
  name: 'App',
  components: {
    SettingExpress,
    SoundAlarm,
    ShoopingCartButton,
    ErrorSnackbar,
    Layout,
    DashboardButton,
    AppBarUserMenu,
    LogoToolbar,
    TitleToolbar
  },
  data() {
    return {
      menu: menuConfig
    }
  },
  mounted() {
    this.$store.dispatch('checkAuth')
  },
  watch: {
    '$store.state.user.access_token': {
      handler(val) {
        if (val === null && (this.$route.name != 'login' && this.$route.name != 'recovery')) {
          this.$router.push({name: 'login'})
        }
      }
    }
  },
  computed: {
    ...mapGetters(['me']),
    getUserId() {
      return this.me ? this.me.id : null
    }
  }
};
</script>
